module.exports = __webpack_public_path__ + "static/hyperv_24.2ebda268.jpg";